var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Page',{attrs:{"title":"Admin","items":_vm.items}},[_c('SalesForceOrganizationLoad')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }